import React from 'react';
import { useIntl } from 'react-intl';

// One line of feedback: a loading note, an empty state or an error with an optional retry.
export const StatusMessage = ({ id, tone = 'info', values, onRetry }) => {
  const { formatMessage } = useIntl();
  const role = tone === 'error' ? 'alert' : 'status';

  return (
    <div className={`request-video-status request-video-status-${tone}`} role={role}>
      <span>{formatMessage({ id }, values)}</span>
      {onRetry && (
        <button type="button" className="request-video-link-button" onClick={onRetry}>
          {formatMessage({ id: 'requestVideo_retry' })}
        </button>
      )}
    </div>
  );
};
